import React, { useState, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import './MobileMenuBar.css';
import Logo from '../menubar/Logo'
import UserDots from "../menubar/UserDots";
import { FaBars, FaChevronDown } from "react-icons/fa"; // Icons for open/close

const MobileMenuBar = () => {
  const { moduleAccess } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);

  const menuItems = [
    { name: 'About', path: '/ceo', accessKey: 'about' },
    { name: 'Bakery', path: '/bakery', accessKey: 'bakery' },
    { name: 'Butchery', path: '/butchery', accessKey: 'butchery' },
    { name: 'Fruit & Veg', path: '/fruitveg', accessKey: 'fruitveg' },
    { name: 'Take-away', path: '/takeaway', accessKey: 'takeaway' },
    { name: 'CFC', path: '/cfc', accessKey: 'cfc' },
    { name: 'Br. Manager', path: '/brmanager', accessKey: 'brmanager' },
  ];

  const handleClick = (path) => {
    navigate(path);
    setExpanded(false); // Collapse after selection
  };

  const currentName = menuItems.find(item => item.path === location.pathname)?.name || 'Home';

  return (
    <div className="mobile-menubar">
      <Logo></Logo>
  
      <div className="menubar-toggle" onClick={() => setExpanded(!expanded)}>
          {expanded ? <><FaChevronDown /> </> : <FaBars /> } {currentName}
      </div>

      
      <div className={`menubar-dropdown ${expanded ? 'show' : ''}`}>
        {menuItems
          .filter(item => moduleAccess[item.accessKey])
          .map((item, index) => (
            <button
              key={index}
              className={`menu-button ${location.pathname === item.path ? 'active' : ''}`}
              onClick={() => handleClick(item.path)}
            >
              {item.name}
            </button>
          ))}
      </div>
      <UserDots />
    </div>
  );
};

export default MobileMenuBar;
